import React from "react";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import { ProfileModalContentWrapper } from "../shared/Modal/Modal.styles";
import { SuccessMessageWrapper } from "./SuccessMessage.styles";
import { IntermediateSuccessMessage } from "./IntermediateSuccessMessage";

interface IntermediateSuccessConfirmationProps {
  onPrimaryAction: () => void;
  onSecondaryAction?: () => void;
}

export const IntermediateSuccessConfirmation: React.FC<
  IntermediateSuccessConfirmationProps
> = ({ onPrimaryAction, onSecondaryAction }) => {
  const { deviceType } = useDeviceHook();

  return (
    <SuccessMessageWrapper deviceType={deviceType}>
      <ProfileModalContentWrapper>
        <IntermediateSuccessMessage
          onPrimaryAction={onPrimaryAction}
          onSecondaryAction={onSecondaryAction}
        />
      </ProfileModalContentWrapper>
    </SuccessMessageWrapper>
  );
};
